import { TriangleAlertIcon } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface RefreshWarningDialogProps {
  open: boolean;
  onDismiss: () => void;
  onConfirmRefresh: () => void;
}

export function RefreshWarningDialog({ open, onDismiss, onConfirmRefresh }: RefreshWarningDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onDismiss()}>
      <DialogContent showCloseButton={false} onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600">
              <TriangleAlertIcon className="size-5" />
            </div>
            <DialogTitle>페이지를 새로고침하시겠습니까?</DialogTitle>
          </div>
          <DialogDescription className="pt-2">
            현재 로그인 정보가 초기화되며, 새로고침하면 로그아웃됩니다.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onDismiss}>
            취소
          </Button>
          <Button variant="destructive" onClick={onConfirmRefresh}>
            새로고침
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
